const type = "SENSOR/";

export const sensorConstants = {
  LISTING_REQUEST: `${type}LISTING_REQUEST`,
  LISTING_SUCCESS: `${type}LISTING_SUCCESS`,
  LISTING_FAILURE: `${type}LISTING_FAILURE`,
};
